import { css } from '@emotion/react';
import {
  type FC, type HTMLAttributes, type PropsWithChildren,
} from 'react';

type FloatingBoxWrapperProps = PropsWithChildren<{
  className?: string;
}>;

const wrapperStyle = css({
  position: 'absolute',
  top: 0,
  left: 0,
});

export const FloatingBoxWrapper: FC<FloatingBoxWrapperProps & HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
  return (
    <div
      css={wrapperStyle}
      {...props}
    >
      {children}
    </div>
  );
};
